export default __webpack_public_path__ + "static/g3-dark-logo-icon-38d1488c09f140a3c9508e297296da56.svg";